import './Navbar.scss';

import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Icon from 'atoms/icon';
import useWindowDimensions from 'hooks/useWindowDimensions';
import NavbarContent from 'organisms/DrawerContent/NavbarContent';
import { closeDrawer, openDrawer } from 'store/reducers/ui';

function Navbar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { width } = useWindowDimensions();
  const isDesktop = width > 1200;
  const isTablet = width < 1200;
  const isMobile = width < 600;

  if (isMobile) {
    return null;
  }

  const hideUrls = [
    'signup',
    'consumer',
    'login',
    'password',
    'privacy',
    'add-service',
    'add-service-optional',
  ];

  if (
    hideUrls.some((el) => location.pathname.includes(el)) ||
    location.pathname === '/'
  ) {
    return null;
  }

  const openNavbarDrawer = (open) => {
    if (!open) {
      return dispatch(closeDrawer());
    }
    dispatch(openDrawer({ type: 'navbar', position: 'left' }));
  };

  return (
    <button
      onClick={isTablet ? () => openNavbarDrawer(true) : null}
      className="no-style-btn"
    >
      {isDesktop && <NavbarContent />}
      {isTablet && (
        <div className="navbar-drawer-toggle">
          <div>
            <Icon name="arrow-down" />
          </div>
        </div>
      )}
    </button>
  );
}

export default Navbar;
